// Module
var code = `<section aria-labelledby="hero-headline">
    <p class="hero-eyebrow">SIX YEARS IN PRODUCTION · OPEN SOURCE · STRUCTURAL API BETA</p>
    <h1 class="hero-headline">A frontend framework with explicit structure.</h1>
    <p class="hero-sub-1">SpyneJS applications are queryable as data — AI agents read and write through a Structural API instead of guessing at source.</p>

    <p class="hero-sub-2">
        No virtual DOM. The codebase maps directly to the application — durable boundaries developers govern, structural context AI can actually use.
    </p>

    <div class="cta-buttons">
        <a
                data-channel="ROUTE"
                data-event-prevent-default="true"
                data-page-id="docs"
                data-stage="examples"
                data-text="Docs"
                href="/docs/examples"

                class="landing-btn landing-btn-primary">Inspect Live Examples</a>
        <a data-channel="ROUTE"
           data-event-prevent-default="true"
           data-page-id="configure"
           href="/configure" class="landing-btn landing-btn-outline">Open the Application Builder</a>
    </div>


</section>
`;
// Exports
module.exports = code;